import React from 'react'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
const TimeInputField = ({ data, setData }) => {
    const handleInputChange = (index, field, value) => {
        let openTime;
        let closeTime;
        const newInputs = [...data];
        if (field === 'startHour') {
            if (new Date(value).getMinutes() == 0) {
                openTime = new Date(value).getHours() + ':' + new Date(value).getMinutes() + '0';
            }
            else {
                openTime = new Date(value).getHours() + ':' + new Date(value).getMinutes();
            }
            if (new Date(value).getHours() < 10) {
                openTime = '0' + openTime
            }
            newInputs[index][field] = openTime;
        }
        else {
            if (new Date(value).getMinutes() == 0) {
                closeTime = new Date(value).getHours() + ':' + new Date(value).getMinutes() + '0';
            }
            else {
                closeTime = new Date(value).getHours() + ':' + new Date(value).getMinutes();
            }
            if (new Date(value).getHours() < 10) {
                closeTime = '0' + closeTime
            }
            newInputs[index][field] = closeTime;
        }
        setData("timeDetails",newInputs);
    };
    const handleCheckboxChange = (index) => {
        const newInputs = [...data];
        newInputs[index].isOpen = !newInputs[index].isOpen;
        setData("timeDetails",newInputs);
    };
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return (
        <>
            {data.map((item, index) =>
                <div key={index} className={item.isOpen ? 'day_time_input_con' : 'day_time_input_con active'}>
                    <div className={item.isOpen ? 'day_and_time_container' : 'day_and_time_container active'}>
                        {daysOfWeek.map((day, index) =>
                            <>
                                {item.day == index &&
                                    <TextField InputProps={{ readOnly: true }}
                                        variant='outlined'
                                        value={day}
                                        className={item.isOpen ? 'calender-setting-text-input' : 'calender-setting-text-input active'}
                                        label='Day' />}
                            </>)}
                        {item.isOpen &&
                            <TimePicker
                                sx={{
                                    width: '45%',
                                    '@media (max-width:400px)': {
                                        width: '100%',
                                    },
                                    '@media (min-width:501px) and (max-width:700px)': {
                                        width: '75%',
                                    },
                                }}
                                className='calender-setting-time-picker'
                                onChange={(e) => handleInputChange(index, "startHour", e)}
                                value={dayjs(item.startHour, 'HH:mm') || ''}
                                label="Open" />}
                    </div>
                    <div className={item.isOpen ? 'time_and_is_open' : 'time_and_is_open active'}>
                        {item.isOpen &&
                            <TimePicker
                                sx={{
                                    '@media (max-width:400px)': {
                                        width: '100%',
                                    },
                                    '@media (min-width:501px) and (max-width:700px)': {
                                        width: '90%',
                                    },
                                }}
                                className='calender-setting-time-picker'
                                onChange={(e) => handleInputChange(index, "endHour", e)}
                                value={dayjs(item.endHour, 'HH:mm') || ''}
                                label="Close" />}
                        {!item.isOpen &&
                            <div className='closed_text'>
                                <img src="src\assets\images\closed.png" alt="" />
                            </div>}
                        <div className="checkbox-wrapper-5">
                            <div className="check" >
                                <input id={`check-${index}`} checked={item.isOpen} onChange={() => handleCheckboxChange(index)} type="checkbox" />
                                <label htmlFor={`check-${index}`}></label>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
export default TimeInputField